const Icon = ({ icon, color = "" }) => {
    switch (icon) {
        case "cross":
            return (
                <svg
                    fill="none"
                    height="10"
                    viewBox="0 0 10 10"
                    width="10"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9 1L0.999999 9"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M1 1L9 9"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeWidth="1.1"
                    />
                </svg>
            );

        case "search":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M21.0002 21L16.7002 16.7M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );

        case "more":
            return (
                <svg
                    fill="none"
                    height="40"
                    viewBox="0 0 24 24"
                    width="40"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        clipRule="evenodd"
                        d="M7 10.5C6.175 10.5 5.5 11.175 5.5 12C5.5 12.825 6.175 13.5 7 13.5C7.825 13.5 8.5 12.825 8.5 12C8.5 11.175 7.825 10.5 7 10.5Z"
                        fill={color || "currentColor"}
                        fillRule="evenodd"
                    />
                    <path
                        clipRule="evenodd"
                        d="M12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
                        fill={color || "currentColor"}
                        fillRule="evenodd"
                    />
                    <path
                        clipRule="evenodd"
                        d="M17 10.5C16.175 10.5 15.5 11.175 15.5 12C15.5 12.825 16.175 13.5 17 13.5C17.825 13.5 18.5 12.825 18.5 12C18.5 11.175 17.825 10.5 17 10.5Z"
                        fill={color || "currentColor"}
                        fillRule="evenodd"
                    />
                </svg>
            );
        case "pencil":
            return (
                <svg
                    fill="none"
                    height="26"
                    viewBox="0 0 20 20"
                    width="26"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7.84772 15.6432L3 17L4.35736 12.1542L13.2341 3.324C13.3344 3.22143 13.4542 3.13994 13.5865 3.0843C13.7188 3.02866 13.8608 3 14.0043 3C14.1478 3 14.2899 3.02866 14.4222 3.0843C14.5544 3.13994 14.6742 3.22143 14.7746 3.324L16.6813 5.24079C16.7823 5.3409 16.8625 5.46 16.9171 5.59122C16.9718 5.72245 17 5.8632 17 6.00536C17 6.14751 16.9718 6.28826 16.9171 6.41949C16.8625 6.55071 16.7823 6.66981 16.6813 6.76992L7.84772 15.6432Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                </svg>
            );
        case "dots":
            return (
                <svg
                    fill="none"
                    height="25"
                    viewBox="0 0 16 16"
                    width="25"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        clipRule="evenodd"
                        d="M4.92261 4.15375C4.92261 4.78838 5.44185 5.30762 6.07647 5.30762C6.7111 5.30762 7.23034 4.78838 7.23034 4.15375C7.23034 3.51913 6.7111 2.99989 6.07647 2.99989C5.44185 2.99989 4.92261 3.51913 4.92261 4.15375Z"
                        fill={color || "currentColor"}
                        fillRule="evenodd"
                    />
                    <path
                        clipRule="evenodd"
                        d="M8.76855 4.15375C8.76855 4.78838 9.28779 5.30762 9.92242 5.30762C10.557 5.30762 11.0763 4.78838 11.0763 4.15375C11.0763 3.51913 10.557 2.99989 9.92242 2.99989C9.28779 2.99989 8.76855 3.51913 8.76855 4.15375Z"
                        fill={color || "currentColor"}
                        fillRule="evenodd"
                    />
                    <path
                        clipRule="evenodd"
                        d="M4.92261 8.00043C4.92261 8.63506 5.44185 9.1543 6.07647 9.1543C6.7111 9.1543 7.23034 8.63506 7.23034 8.00043C7.23034 7.36581 6.7111 6.84657 6.07647 6.84657C5.44185 6.84657 4.92261 7.36581 4.92261 8.00043Z"
                        fill={color || "currentColor"}
                        fillRule="evenodd"
                    />
                    <path
                        clipRule="evenodd"
                        d="M8.76855 8.00043C8.76855 8.63506 9.28779 9.1543 9.92242 9.1543C10.557 9.1543 11.0763 8.63506 11.0763 8.00043C11.0763 7.36581 10.557 6.84657 9.92242 6.84657C9.28779 6.84657 8.76855 7.36581 8.76855 8.00043Z"
                        fill={color || "currentColor"}
                        fillRule="evenodd"
                    />
                    <path
                        clipRule="evenodd"
                        d="M4.92261 11.8461C4.92261 12.4808 5.44185 13 6.07647 13C6.7111 13 7.23034 12.4808 7.23034 11.8461C7.23034 11.2115 6.7111 10.6923 6.07647 10.6923C5.44185 10.6923 4.92261 11.2115 4.92261 11.8461Z"
                        fill={color || "currentColor"}
                        fillRule="evenodd"
                    />
                    <path
                        clipRule="evenodd"
                        d="M8.76855 11.8461C8.76855 12.4808 9.28779 13 9.92242 13C10.557 13 11.0763 12.4808 11.0763 11.8461C11.0763 11.2115 10.557 10.6923 9.92242 10.6923C9.28779 10.6923 8.76855 11.2115 8.76855 11.8461Z"
                        fill={color || "currentColor"}
                        fillRule="evenodd"
                    />
                </svg>
            );

        case "filters":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 21 20"
                    width="21"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5.11565 6.23106C6.00782 6.23106 6.73106 5.50782 6.73106 4.61565C6.73106 3.72349 6.00782 3.00024 5.11565 3.00024C4.22349 3.00024 3.50024 3.72349 3.50024 4.61565C3.50024 5.50782 4.22349 6.23106 5.11565 6.23106Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M6.73083 4.61603H17.5002"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M10.5008 11.6159C11.3929 11.6159 12.1162 10.8927 12.1162 10.0005C12.1162 9.10837 11.3929 8.38513 10.5008 8.38513C9.60862 8.38513 8.88538 9.10837 8.88538 10.0005C8.88538 10.8927 9.60862 11.6159 10.5008 11.6159Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M3.50024 10.0001H8.88493"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M12.115 10.0001H17.4997"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M15.8846 17C16.7767 17 17.5 16.2767 17.5 15.3846C17.5 14.4924 16.7767 13.7692 15.8846 13.7692C14.9924 13.7692 14.2692 14.4924 14.2692 15.3846C14.2692 16.2767 14.9924 17 15.8846 17Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M14.2696 15.3841H3.50024"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                </svg>
            );

        case "refresh":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M21 12C21 13.78 20.4722 15.5201 19.4832 17.0001C18.4943 18.4802 17.0887 19.6337 15.4442 20.3149C13.7996 20.9961 11.99 21.1743 10.2442 20.8271C8.49836 20.4798 6.89472 19.6226 5.63604 18.364C4.37737 17.1053 3.5202 15.5016 3.17294 13.7558C2.82567 12.01 3.0039 10.2004 3.68509 8.55585C4.36628 6.91131 5.51983 5.50571 6.99987 4.51677C8.47991 3.52784 10.22 3 12 3C14.52 3 16.93 4 18.74 5.74L21 8M16 8H21L21 3"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );

        case "export":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 21 20"
                    width="21"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M17.5 11.0769V15.9231C17.5 16.2087 17.3866 16.4826 17.1846 16.6846C16.9826 16.8866 16.7087 17 16.4231 17H4.57692C4.29131 17 4.01739 16.8866 3.81542 16.6846C3.61346 16.4826 3.5 16.2087 3.5 15.9231V4.07692C3.5 3.79131 3.61346 3.51739 3.81542 3.31542C4.01739 3.11346 4.29131 3 4.57692 3H9.42309"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M13.731 3.00006H17.5002V6.7693"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M17.5 3.00006L10.5 10.0001"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                </svg>
            );
        case "order_by":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 16 16"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2 9.33331L4.66667 12L7.33333 9.33331"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M14 6.66669L11.3333 4.00002L8.66667 6.66669"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M4.66663 12L4.66663 4"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M11.3334 4L11.3334 12"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                </svg>
            );

        case "checkbox":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 20 20"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        clipRule="evenodd"
                        d="M15.0001 2.49969H4.99976C3.61904 2.49969 2.49976 3.61898 2.49976 4.9997V15C2.49976 16.3807 3.61904 17.5 4.99976 17.5H15.0001C16.3808 17.5 17.5001 16.3807 17.5001 15V4.99969C17.5001 3.61898 16.3808 2.49969 15.0001 2.49969ZM4.99976 0.999695C2.79062 0.999695 0.999756 2.79056 0.999756 4.9997V15C0.999756 17.2092 2.79062 19 4.99976 19H15.0001C17.2092 19 19.0001 17.2092 19.0001 15V4.99969C19.0001 2.79056 17.2092 0.999695 15.0001 0.999695H4.99976Z"
                        fill={color || "currentColor"}
                        fillRule="evenodd"
                    />
                </svg>
            );

        case "checkbox_variant":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="1 0 20 20"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        clipRule="evenodd"
                        d="M5.6665 0.999664C3.45736 0.999664 1.6665 2.79053 1.6665 4.99967V15C1.6665 17.2091 3.45737 19 5.66651 19H15.6668C17.876 19 19.6668 17.2091 19.6668 15V4.99966C19.6668 2.79053 17.876 0.999664 15.6668 0.999664H5.6665ZM14.9326 7.90566C15.2672 7.53804 15.2403 6.9688 14.8727 6.63424C14.5051 6.29968 13.9359 6.32648 13.6013 6.69411L9.3041 11.416L7.68487 9.88585C7.32359 9.54444 6.75395 9.56055 6.41254 9.92182C6.07113 10.2831 6.08724 10.8527 6.44852 11.1942L8.73431 13.3542C8.90993 13.5202 9.14491 13.6086 9.38637 13.5995C9.62784 13.5904 9.8555 13.4846 10.0181 13.3059L14.9326 7.90566Z"
                        fill={color || "#D5D9E6"}
                        fillRule="evenodd"
                    />
                </svg>
            );

        case "alert":
            return (
                <svg
                    fill="none"
                    height="25"
                    viewBox="0 0 20 20"
                    width="25"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M10 10.7778L10 6.88889"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M10.0001 12.3333C9.5705 12.3333 9.22228 12.6816 9.22228 13.1111C9.22228 13.5407 9.5705 13.8889 10.0001 13.8889C10.4296 13.8889 10.7778 13.5407 10.7778 13.1111C10.7778 12.6816 10.4296 12.3333 10.0001 12.3333Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case "delete":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3.77832 5.33325L16.2228 5.33325"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.33333"
                    />
                    <path
                        d="M5.33423 5.33325L14.6676 5.33325V15.8954C14.6676 16.1883 14.5667 16.4693 14.3872 16.6764C14.2077 16.8835 13.9642 16.9999 13.7103 16.9999H6.2915C6.03761 16.9999 5.79413 16.8835 5.61461 16.6764C5.43508 16.4693 5.33423 16.1883 5.33423 15.8954L5.33423 5.33325Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.33333"
                    />
                    <path
                        d="M7.66748 5.33333V4.94444C7.66748 4.42875 7.91331 3.93417 8.3509 3.56951C8.78848 3.20486 9.38198 3 10.0008 3C10.6197 3 11.2131 3.20486 11.6507 3.56951C12.0883 3.93417 12.3341 4.42875 12.3341 4.94444V5.33333"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.33333"
                    />
                    <path
                        d="M8.44495 8.44409L8.44495 13.8885"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.33333"
                    />
                    <path
                        d="M11.5558 8.44409L11.5558 13.8885"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.33333"
                    />
                </svg>
            );
        case "kanban":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M19 5H5"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.33333"
                    />
                    <path
                        d="M17.9226 13.6155V8.76931C17.9226 8.17454 17.4405 7.69238 16.8457 7.69238H14.6918C14.0971 7.69238 13.6149 8.17454 13.6149 8.76931V13.6155C13.6149 14.2102 14.0971 14.6924 14.6918 14.6924H16.8457C17.4405 14.6924 17.9226 14.2102 17.9226 13.6155Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.33333"
                    />
                    <path
                        d="M10.385 17.9232V8.76931C10.385 8.17454 9.90285 7.69238 9.30809 7.69238H7.15424C6.55947 7.69238 6.07732 8.17454 6.07732 8.76931L6.07732 17.9232C6.07732 18.5179 6.55947 19.0001 7.15424 19.0001H9.30809C9.90285 19.0001 10.385 18.5179 10.385 17.9232Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.33333"
                    />
                </svg>
            );
        case "table":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15.9231 3H4.07692C3.48215 3 3 3.48215 3 4.07692V15.9231C3 16.5178 3.48215 17 4.07692 17H15.9231C16.5178 17 17 16.5178 17 15.9231V4.07692C17 3.48215 16.5178 3 15.9231 3Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.33333"
                    />
                    <path
                        d="M7.84521 3V17"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.33333"
                    />
                    <path
                        d="M12.1548 3V17"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.33333"
                    />
                    <path
                        d="M17 7.84619H3"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.33333"
                    />
                    <path
                        d="M17 12.1538H3"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.33333"
                    />
                </svg>
            );
        case "setting":
            return (
                <svg
                    fill="none"
                    height="22"
                    viewBox="0 0 20 22"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7.33074 3.69231L7.9792 1.98462C8.08856 1.69548 8.28097 1.44679 8.53122 1.2711C8.78148 1.09541 9.07791 1.00092 9.3817 1H10.6183C10.9221 1.00092 11.2185 1.09541 11.4688 1.2711C11.719 1.44679 11.9114 1.69548 12.0208 1.98462L12.6693 3.69231L14.871 4.98462L16.6505 4.70769C16.9468 4.66666 17.2484 4.71642 17.5169 4.85065C17.7855 4.98488 18.0088 5.19752 18.1586 5.46154L18.7618 6.53846C18.9164 6.80669 18.9876 7.11643 18.9661 7.4268C18.9445 7.73717 18.8313 8.03359 18.6412 8.27692L17.5403 9.70769V12.2923L18.6713 13.7231C18.8614 13.9664 18.9747 14.2628 18.9962 14.5732C19.0178 14.8836 18.9466 15.1933 18.792 15.4615L18.1888 16.5385C18.039 16.8025 17.8156 17.0151 17.5471 17.1493C17.2786 17.2836 16.977 17.3333 16.6807 17.2923L14.9012 17.0154L12.6994 18.3077L12.051 20.0154C11.9416 20.3045 11.7492 20.5532 11.4989 20.7289C11.2487 20.9046 10.9522 20.9991 10.6485 21H9.3817C9.07791 20.9991 8.78148 20.9046 8.53122 20.7289C8.28097 20.5532 8.08856 20.3045 7.9792 20.0154L7.33074 18.3077L5.12897 17.0154L3.34946 17.2923C3.05315 17.3333 2.75158 17.2836 2.48305 17.1493C2.21453 17.0151 1.99119 16.8025 1.8414 16.5385L1.23818 15.4615C1.08361 15.1933 1.01239 14.8836 1.03393 14.5732C1.05547 14.2628 1.16875 13.9664 1.35882 13.7231L2.45971 12.2923V9.70769L1.32866 8.27692C1.13859 8.03359 1.0253 7.73717 1.00377 7.4268C0.982227 7.11643 1.05344 6.80669 1.20802 6.53846L1.81124 5.46154C1.96103 5.19752 2.18437 4.98488 2.45289 4.85065C2.72142 4.71642 3.02299 4.66666 3.3193 4.70769L5.09881 4.98462L7.33074 3.69231ZM6.98388 11C6.98388 11.6086 7.16077 12.2034 7.49219 12.7094C7.82361 13.2154 8.29466 13.6098 8.84578 13.8427C9.3969 14.0756 10.0033 14.1365 10.5884 14.0178C11.1735 13.8991 11.7109 13.606 12.1327 13.1757C12.5545 12.7454 12.8418 12.1971 12.9582 11.6003C13.0745 11.0034 13.0148 10.3847 12.7865 9.82251C12.5582 9.26028 12.1717 8.77973 11.6757 8.44163C11.1797 8.10354 10.5965 7.92308 10 7.92308C9.20008 7.92308 8.43291 8.24725 7.86728 8.82429C7.30165 9.40132 6.98388 10.1839 6.98388 11V11Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                </svg>
            );

        case "notifications":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10 1C11.5754 1 13.0862 1.61017 14.2002 2.69629C15.3142 3.78241 15.94 5.2555 15.94 6.7915C15.94 13.231 18.3492 14.5 19 14.5H1C1.66462 14.5 4.06 13.2175 4.06 6.7915C4.06 5.2555 4.68582 3.78241 5.79979 2.69629C6.91375 1.61017 8.42461 1 10 1V1Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M7.75 17.875C7.87966 18.1972 8.1709 18.4824 8.57808 18.686C8.98526 18.8896 9.48536 19 10 19C10.5146 19 11.0147 18.8896 11.4219 18.686C11.8291 18.4824 12.1203 18.1972 12.25 17.875"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                </svg>
            );
        case "store":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2 13L2 18.3C2 18.4857 2.07662 18.6637 2.21301 18.795C2.3494 18.9263 2.53439 19 2.72727 19H17.2727C17.4656 19 17.6506 18.9263 17.787 18.795C17.9234 18.6637 18 18.4857 18 18.3V13"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M10 13L10 19"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M2 16H10"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M1.04102 5.835L3.11316 1H16.9274L18.9996 5.835H1.04102Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M6.91251 5.83496V7.21639C6.91251 7.94914 6.62142 8.65189 6.10329 9.17002C5.58515 9.68816 4.88241 9.97924 4.14965 9.97924H3.76286C3.0301 9.97924 2.32736 9.68816 1.80922 9.17002C1.29109 8.65189 1 7.94914 1 7.21639V5.83496"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M13.1285 5.83496V7.21639C13.1285 7.94914 12.8374 8.65189 12.3193 9.17002C11.8012 9.68816 11.0984 9.97924 10.3657 9.97924H9.67496C8.94221 9.97924 8.23947 9.68816 7.72133 9.17002C7.20319 8.65189 6.91211 7.94914 6.91211 7.21639V5.83496"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M19 5.83496V7.21639C19 7.94914 18.7089 8.65189 18.1908 9.17002C17.6726 9.68816 16.9699 9.97924 16.2371 9.97924H15.8918C15.159 9.97924 14.4563 9.68816 13.9381 9.17002C13.42 8.65189 13.1289 7.94914 13.1289 7.21639V5.83496"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                </svg>
            );
        case "shopping-cart":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.824 7.40039L13.424 8.60039"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M9.24478 7.40039L9.64478 8.60039"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M16.3677 10.9999L6 11L5 5H17.3831C17.4737 5.00032 17.5631 5.01989 17.645 5.05732C17.7269 5.09476 17.7993 5.14914 17.8572 5.21665C17.915 5.28416 17.9569 5.36315 17.9798 5.44804C18.0027 5.53294 18.0062 5.62167 17.9899 5.70799L16.9745 10.508C16.9508 10.6467 16.8765 10.7727 16.7652 10.863C16.6539 10.9532 16.5128 11.0018 16.3677 10.9999Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M14 14H6.58336L6 11"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M5 5L4.496 2.6C4.46834 2.4306 4.3947 2.27834 4.28755 2.169C4.1804 2.05967 4.04632 1.99996 3.908 2H2"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M13 18C12.4477 18 12 17.5523 12 17C12 16.4477 12.4477 16 13 16C13.5523 16 14 16.4477 14 17C14 17.5523 13.5523 18 13 18Z"
                        fill={color || "currentColor"}
                    />
                    <path
                        d="M8 18C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16C8.55228 16 9 16.4477 9 17C9 17.5523 8.55228 18 8 18Z"
                        fill={color || "currentColor"}
                    />
                </svg>
            );
        case "dashboard":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M18.2585 8.41162H12.3291C11.9197 8.41162 11.5879 8.75023 11.5879 9.16792V18.2436C11.5879 18.6612 11.9197 18.9999 12.3291 18.9999H18.2585C18.6678 18.9999 18.9997 18.6612 18.9997 18.2436V9.16792C18.9997 8.75023 18.6678 8.41162 18.2585 8.41162Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M18.2585 1H12.3291C11.9197 1 11.5879 1.31498 11.5879 1.70354V4.53176C11.5879 4.92031 11.9197 5.23529 12.3291 5.23529H18.2585C18.6678 5.23529 18.9997 4.92031 18.9997 4.53176V1.70354C18.9997 1.31498 18.6678 1 18.2585 1Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M7.67059 1H1.74118C1.33184 1 1 1.33861 1 1.7563V10.8319C1 11.2496 1.33184 11.5882 1.74118 11.5882H7.67059C8.07993 11.5882 8.41177 11.2496 8.41177 10.8319V1.7563C8.41177 1.33861 8.07993 1 7.67059 1Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M7.67059 14.7646H1.74118C1.33184 14.7646 1 15.0796 1 15.4682V18.2964C1 18.685 1.33184 18.9999 1.74118 18.9999H7.67059C8.07993 18.9999 8.41177 18.685 8.41177 18.2964V15.4682C8.41177 15.0796 8.07993 14.7646 7.67059 14.7646Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                </svg>
            );
        case "costumers":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10.0004 11.2311C11.6998 11.2311 13.0774 9.85351 13.0774 8.15413C13.0774 6.45476 11.6998 5.07715 10.0004 5.07715C8.30108 5.07715 6.92346 6.45476 6.92346 8.15413C6.92346 9.85351 8.30108 11.2311 10.0004 11.2311Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M4.74377 16.0313C5.29301 15.1298 6.06492 14.3847 6.98531 13.8677C7.90569 13.3507 8.94361 13.0791 9.99927 13.0791C11.0549 13.0791 12.0928 13.3507 13.0132 13.8677C13.9336 14.3847 14.7055 15.1298 15.2548 16.0313"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M9.9998 18.0003C14.4182 18.0003 18 14.4185 18 10.0002C18 5.58179 14.4182 2 9.9998 2C5.58143 2 1.99963 5.58179 1.99963 10.0002C1.99963 14.4185 5.58143 18.0003 9.9998 18.0003Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                </svg>
            );

        case "costumers-all":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21M22 20.9999V18.9999C21.9993 18.1136 21.7044 17.2527 21.1614 16.5522C20.6184 15.8517 19.8581 15.3515 19 15.1299M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );

        case "costumers-selected":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21M16 11L18 13L22 9M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );

        case "shopping-bag":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        height="11.6667"
                        rx="0.833333"
                        stroke="currentColor"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                        width="11.6667"
                        x="4.16602"
                        y="5.8335"
                    />
                    <path
                        d="M12.499 8.33333V5C12.499 3.61929 11.3797 2.5 9.99902 2.5C8.61831 2.5 7.49902 3.61929 7.49902 5V8.33333"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                </svg>
            );

        case "promotion":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M16.7629 12.5536L12.554 16.7624C12.4019 16.9144 12.1956 16.9997 11.9806 16.9997C11.7656 16.9997 11.5593 16.9144 11.4072 16.7624L4.36352 9.71879C4.32155 9.67866 4.28908 9.62967 4.26848 9.57538C4.24789 9.52109 4.2397 9.46288 4.2445 9.40502L4.88286 5.25024C4.8903 5.15516 4.93145 5.06585 4.9989 4.99841C5.06634 4.93096 5.15564 4.88982 5.25073 4.88237L9.4055 4.24401C9.46337 4.23921 9.52158 4.2474 9.57586 4.26799C9.63015 4.28859 9.67915 4.32106 9.71928 4.36303L16.7629 11.4067C16.9149 11.5588 17.0002 11.7651 17.0002 11.9801C17.0002 12.1952 16.9149 12.4014 16.7629 12.5536Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M6.7869 6.7869L3 3"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                </svg>
            );

        case "car":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3.33398 8.33317L5.59123 4.57109C5.74184 4.32009 6.01309 4.1665 6.30581 4.1665H13.6955C13.9882 4.1665 14.2595 4.32009 14.4101 4.57109L16.6673 8.33317"
                        stroke={color || "currentColor"}
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <circle
                        cx="6.87565"
                        cy="11.2497"
                        fill={color || "currentColor"}
                        r="1.04167"
                    />
                    <circle
                        cx="13.1257"
                        cy="11.2497"
                        fill={color || "currentColor"}
                        r="1.04167"
                    />
                    <rect
                        height="5.83333"
                        stroke={color || "currentColor"}
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                        width="13.3333"
                        x="3.33398"
                        y="8.33301"
                    />
                    <rect
                        fill={color || "currentColor"}
                        height="1.66667"
                        stroke={color || "currentColor"}
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                        width="1.66667"
                        x="3.33398"
                        y="14.1665"
                    />
                    <rect
                        fill={color || "currentColor"}
                        height="1.66667"
                        stroke={color || "currentColor"}
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                        width="1.66667"
                        x="15.001"
                        y="14.1665"
                    />
                </svg>
            );

        case "stats_arrow":
            return (
                <svg
                    fill="none"
                    height="12"
                    viewBox="0 0 12 12"
                    width="12"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2.0002 10L9.99998 2"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M4.62158 2H9.99973V7.37815"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );

        case "stats_customers":
            return (
                <svg
                    fill="none"
                    height="16"
                    viewBox="0 0 17 16"
                    width="17"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.33325 8C9.99011 8 11.3333 6.65685 11.3333 5C11.3333 3.34315 9.99011 2 8.33325 2C6.6764 2 5.33325 3.34315 5.33325 5C5.33325 6.65685 6.6764 8 8.33325 8Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M14.3333 14C13.9257 12.911 13.125 11.9611 12.0466 11.2871C10.9683 10.6132 9.66801 10.25 8.33325 10.25C6.99849 10.25 5.69821 10.6132 4.61987 11.2871C3.54153 11.9611 2.74085 12.911 2.33325 14H14.3333Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                </svg>
            );

        case "stats_orders":
            return (
                <svg
                    fill="none"
                    height="16"
                    viewBox="0 0 17 16"
                    width="17"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        height="9.33333"
                        rx="0.666667"
                        stroke={color || "currentColor"}
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                        width="9.33333"
                        x="4.00024"
                        y="4.66667"
                    />
                    <path
                        d="M10.667 6.66667V4C10.667 2.89543 9.77156 2 8.66699 2C7.56242 2 6.66699 2.89543 6.66699 4V6.66667"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                </svg>
            );

        case "stats_revenue":
            return (
                <svg
                    fill="none"
                    height="16"
                    viewBox="0 0 16 16"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9.84672 8.46547C12.1408 8.46547 14.0006 7.63947 14.0006 6.62056C14.0006 5.60164 12.1408 4.77565 9.84672 4.77565C7.55261 4.77565 5.69287 5.60164 5.69287 6.62056C5.69287 7.63947 7.55261 8.46547 9.84672 8.46547Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M5.69287 6.62044V12.1552C5.69287 13.1699 7.53902 14.0001 9.84672 14.0001C12.1544 14.0001 14.0006 13.1699 14.0006 12.1552V6.62044"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M14.0006 9.38763C14.0006 10.4023 12.1544 11.2325 9.84672 11.2325C7.53902 11.2325 5.69287 10.4023 5.69287 9.38763"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M9.7536 2.93055C8.67498 2.26535 7.41945 1.94363 6.1536 2.0081C3.85514 2.0081 1.99976 2.8383 1.99976 3.853C1.99976 4.39725 2.53514 4.88615 3.38437 5.23669"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M3.38437 10.7715C2.53514 10.421 1.99976 9.93209 1.99976 9.38784V3.85312"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M3.38437 8.004C2.53514 7.65346 1.99976 7.16456 1.99976 6.62032"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                </svg>
            );

        case "stats_growth":
            return (
                <svg
                    fill="none"
                    height="16"
                    viewBox="0 0 17 16"
                    width="17"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10.6411 4.66684H14.3334V8.35915"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M14.3333 4.66667L9.11787 10.0476C9.03159 10.1349 8.9156 10.1837 8.79479 10.1837C8.67398 10.1837 8.55799 10.1349 8.47171 10.0476L6.34864 7.85715C6.26236 7.7699 6.14637 7.72103 6.02556 7.72103C5.90475 7.72103 5.78876 7.7699 5.70248 7.85715L2.33325 11.3333"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                </svg>
            );

        case "stats_average_order_subtotal":
            return (
                <svg
                    fill="none"
                    height="16"
                    viewBox="0 0 17 16"
                    width="17"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2.6665 14H14.6665"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M6.35881 14V2H2.6665V14"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M10.0514 13.9999V7.53841H6.35913V13.9999"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M13.7436 14V4.76921H10.0513V14"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                </svg>
            );
        case "stats_average_order_total":
            return (
                <svg
                    fill="none"
                    height="16"
                    viewBox="0 0 17 16"
                    width="17"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2.6665 14H14.6665"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M6.35881 14V2H2.6665V14"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M10.0514 13.9999V7.53841H6.35913V13.9999"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                    <path
                        d="M13.7436 14V4.76921H10.0513V14"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.1"
                    />
                </svg>
            );

        case "arrow_right":
            return (
                <svg
                    fill="none"
                    height="32"
                    viewBox="0 0 32 32"
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 8L20 16L12 24"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.1"
                    />
                </svg>
            );
        case "arrow_left":
            return (
                <svg
                    fill="none"
                    height="32"
                    viewBox="0 0 32 32"
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M20 24L12 16L20 8"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.1"
                    />
                </svg>
            );

        case "copy":
            return (
                <svg
                    data-name="Layer 2"
                    //fill="none"
                    height="20"
                    id="a5b357d0-b6bb-4b51-acaf-aaa20a4d1704"
                    viewBox="0 0 35 35"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M20.717,34.748H3.616A3.37,3.37,0,0,1,.25,31.381v-17.1a3.369,3.369,0,0,1,3.366-3.365h17.1a3.368,3.368,0,0,1,3.365,3.365v17.1A3.369,3.369,0,0,1,20.717,34.748ZM3.616,13.416a.866.866,0,0,0-.866.865v17.1a.867.867,0,0,0,.866.867h17.1a.867.867,0,0,0,.865-.867v-17.1a.865.865,0,0,0-.865-.865Z"
                        //fillRule="evenodd"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        d="M31.384,24.079H22.837a1.25,1.25,0,1,1,0-2.5h8.547a.867.867,0,0,0,.866-.866V3.618a.866.866,0,0,0-.866-.865h-17.1a.866.866,0,0,0-.866.865v8.548a1.25,1.25,0,0,1-2.5,0V3.618A3.369,3.369,0,0,1,14.279.253H31.384A3.369,3.369,0,0,1,34.75,3.618v17.1A3.37,3.37,0,0,1,31.384,24.079Z"
                        //fillRule="evenodd"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                </svg>
            );
        case "plus":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10 2.92871V17.0708"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M17.0713 9.99976L2.92915 9.99975"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeWidth="1.4"
                    />
                </svg>
            );

        case "plus-circle":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        cx="10"
                        cy="10"
                        r="8"
                        stroke="currentColor"
                        strokeWidth="1.5"
                    />
                    <path
                        d="M10 6.5v7M6.5 10h7"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeWidth="1.5"
                    />
                </svg>
            );

        case "minus":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M17.0713 9.99976L2.92915 9.99975"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeWidth="1.4"
                    />
                </svg>
            );

        case "push":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.8107 7.66663H14.8996C15.044 7.66663 15.1825 7.72447 15.2846 7.82743C15.3867 7.93039 15.4441 8.07004 15.4441 8.21565V16.4509C15.4441 16.5965 15.3867 16.7362 15.2846 16.8392C15.1825 16.9421 15.044 17 14.8996 17H5.09962C4.95522 17 4.81674 16.9421 4.71464 16.8392C4.61254 16.7362 4.55518 16.5965 4.55518 16.4509V8.21565C4.55518 8.07004 4.61254 7.93039 4.71464 7.82743C4.81674 7.72447 4.95522 7.66663 5.09962 7.66663H6.18851"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M10 10.7778L10 3"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M7.6665 5.33333L9.99984 3L12.3332 5.33333"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                </svg>
            );
        case "status-success":
            return (
                <svg
                    fill="none"
                    height="16"
                    viewBox="0 0 16 16"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M5.6665 8.9133L7.26095 10.2444C7.30377 10.2812 7.35391 10.3076 7.40773 10.3217C7.46154 10.3357 7.51768 10.337 7.57206 10.3256C7.62696 10.3149 7.67899 10.2919 7.72463 10.2583C7.77026 10.2247 7.80842 10.1812 7.8365 10.1308L10.3332 5.66663"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                </svg>
            );
        case "status-error":
            return (
                <svg
                    fill="none"
                    height="16"
                    viewBox="0 0 16 16"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M8 8.77783L8 4.88894"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M8.00054 10.3334C7.57099 10.3334 7.22276 10.6816 7.22276 11.1111C7.22276 11.5407 7.57099 11.8889 8.00054 11.8889C8.4301 11.8889 8.77832 11.5407 8.77832 11.1111C8.77832 10.6816 8.4301 10.3334 8.00054 10.3334Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case "status-building":
            return (
                <svg
                    fill="none"
                    height="16"
                    viewBox="0 0 16 16"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.02718 15C4.14618 15 1 11.866 1 8C1 4.13401 4.14618 1 8.02718 1C11.3016 1 14.0529 3.23085 14.833 6.25"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeWidth="1.41667"
                    />
                    <path
                        d="M10.6631 14.4912C12.9786 13.5575 14.6809 11.4301 15.0007 8.875"
                        stroke="currentColor"
                        strokeDasharray="0.83 2.5"
                        strokeLinecap="round"
                        strokeWidth="1.41667"
                    />
                </svg>
            );

        case "arrow_next":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3 9.99975L17 9.99976"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                    <path
                        d="M12 14.9998L17 9.99976L12 4.99976"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                    />
                </svg>
            );
        case "info":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <mask
                        height="20"
                        id="mask0_4915_62048"
                        maskUnits="userSpaceOnUse"
                        style={{ maskType: "alpha" }}
                        width="20"
                        x="0"
                        y="0"
                    >
                        <rect fill="white" height="20" width="20" />
                    </mask>
                    <g mask="url(#mask0_4915_62048)">
                        <path
                            d="M9.99999 14.167C10.236 14.167 10.441 14.08 10.615 13.906C10.7883 13.7327 10.875 13.528 10.875 13.292V10.021C10.875 9.78499 10.7883 9.58366 10.615 9.41699C10.441 9.25033 10.236 9.16699 9.99999 9.16699C9.76399 9.16699 9.55899 9.25366 9.38499 9.42699C9.21166 9.60099 9.12499 9.80599 9.12499 10.042V13.312C9.12499 13.5487 9.21166 13.7503 9.38499 13.917C9.55899 14.0837 9.76399 14.167 9.99999 14.167ZM9.99999 7.47899C10.236 7.47899 10.441 7.39233 10.615 7.21899C10.7883 7.04499 10.875 6.83999 10.875 6.60399C10.875 6.36799 10.7883 6.16333 10.615 5.98999C10.441 5.81599 10.236 5.72899 9.99999 5.72899C9.76399 5.72899 9.55899 5.81599 9.38499 5.98999C9.21166 6.16333 9.12499 6.36799 9.12499 6.60399C9.12499 6.83999 9.21166 7.04499 9.38499 7.21899C9.55899 7.39233 9.76399 7.47899 9.99999 7.47899ZM9.99999 18.333C8.84733 18.333 7.76399 18.1143 6.74999 17.677C5.73599 17.2397 4.85399 16.646 4.10399 15.896C3.35399 15.146 2.76033 14.264 2.32299 13.25C1.88566 12.236 1.66699 11.1527 1.66699 9.99999C1.66699 8.84733 1.88566 7.76399 2.32299 6.74999C2.76033 5.73599 3.35399 4.85399 4.10399 4.10399C4.85399 3.35399 5.73599 2.76033 6.74999 2.32299C7.76399 1.88566 8.84733 1.66699 9.99999 1.66699C11.1527 1.66699 12.236 1.88566 13.25 2.32299C14.264 2.76033 15.146 3.35399 15.896 4.10399C16.646 4.85399 17.2397 5.73599 17.677 6.74999C18.1143 7.76399 18.333 8.84733 18.333 9.99999C18.333 11.1527 18.1143 12.236 17.677 13.25C17.2397 14.264 16.646 15.146 15.896 15.896C15.146 16.646 14.264 17.2397 13.25 17.677C12.236 18.1143 11.1527 18.333 9.99999 18.333ZM9.99999 16.583C11.8193 16.583 13.3713 15.9407 14.656 14.656C15.9407 13.3713 16.583 11.8193 16.583 9.99999C16.583 8.18066 15.9407 6.62866 14.656 5.34399C13.3713 4.05933 11.8193 3.41699 9.99999 3.41699C8.18066 3.41699 6.62866 4.05933 5.34399 5.34399C4.05933 6.62866 3.41699 8.18066 3.41699 9.99999C3.41699 11.8193 4.05933 13.3713 5.34399 14.656C6.62866 15.9407 8.18066 16.583 9.99999 16.583Z"
                            fill={color || "currentColor"}
                        />
                    </g>
                </svg>
            );
        case "error":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <mask
                        height="20"
                        id="mask0_4915_93538"
                        maskUnits="userSpaceOnUse"
                        style={{ maskType: "alpha" }}
                        width="20"
                        x="0"
                        y="0"
                    >
                        <rect fill="white" height="20" width="20" />
                    </mask>
                    <g mask="url(#mask0_4915_93538)">
                        <path
                            d="M9.99708 5.83984C9.76108 5.83984 9.55608 5.92684 9.38208 6.10084C9.20875 6.27418 9.12208 6.47884 9.12208 6.71484V9.98584C9.12208 10.2218 9.20875 10.4232 9.38208 10.5898C9.55608 10.7565 9.76108 10.8398 9.99708 10.8398C10.2331 10.8398 10.4381 10.7532 10.6121 10.5798C10.7854 10.4058 10.8721 10.2008 10.8721 9.96484L10.8721 6.69484C10.8721 6.45818 10.7854 6.25651 10.6121 6.08984C10.4381 5.92318 10.2331 5.83984 9.99708 5.83984ZM9.99708 12.5278C9.76108 12.5278 9.55608 12.6145 9.38208 12.7878C9.20875 12.9618 9.12208 13.1668 9.12208 13.4028C9.12208 13.6388 9.20875 13.8435 9.38208 14.0168C9.55608 14.1908 9.76108 14.2778 9.99708 14.2778C10.2331 14.2778 10.4381 14.1908 10.6121 14.0168C10.7854 13.8435 10.8721 13.6388 10.8721 13.4028C10.8721 13.1668 10.7854 12.9618 10.6121 12.7878C10.4381 12.6145 10.2331 12.5278 9.99708 12.5278ZM9.99708 1.67384C11.1497 1.67384 12.2331 1.89251 13.2471 2.32984C14.2611 2.76718 15.1431 3.36084 15.8931 4.11084C16.6431 4.86084 17.2367 5.74284 17.6741 6.75684C18.1114 7.77084 18.3301 8.85418 18.3301 10.0068C18.3301 11.1595 18.1114 12.2428 17.6741 13.2568C17.2367 14.2708 16.6431 15.1528 15.8931 15.9028C15.1431 16.6528 14.2611 17.2465 13.2471 17.6838C12.2331 18.1212 11.1497 18.3398 9.99708 18.3398C8.84441 18.3398 7.76108 18.1212 6.74708 17.6838C5.73308 17.2465 4.85108 16.6528 4.10108 15.9028C3.35108 15.1528 2.75741 14.2708 2.32008 13.2568C1.88274 12.2428 1.66408 11.1595 1.66408 10.0068C1.66408 8.85418 1.88274 7.77084 2.32008 6.75684C2.75741 5.74284 3.35108 4.86084 4.10108 4.11084C4.85108 3.36084 5.73308 2.76718 6.74708 2.32984C7.76108 1.89251 8.84441 1.67384 9.99708 1.67384ZM9.99708 3.42384C8.17774 3.42384 6.62574 4.06618 5.34108 5.35084C4.05641 6.63551 3.41408 8.18751 3.41408 10.0068C3.41408 11.8262 4.05641 13.3782 5.34108 14.6628C6.62574 15.9475 8.17774 16.5898 9.99708 16.5898C11.8164 16.5898 13.3684 15.9475 14.6531 14.6628C15.9377 13.3782 16.5801 11.8262 16.5801 10.0068C16.5801 8.18751 15.9377 6.63551 14.6531 5.35084C13.3684 4.06618 11.8164 3.42384 9.99708 3.42384Z"
                            fill={color || "currentColor"}
                        />
                    </g>
                </svg>
            );
        case "warning":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <mask
                        height="20"
                        id="mask0_4915_93569"
                        maskUnits="userSpaceOnUse"
                        style={{ maskType: "alpha" }}
                        width="20"
                        x="0"
                        y="0"
                    >
                        <rect fill="white" height="20" width="20" />
                    </mask>
                    <g mask="url(#mask0_4915_93569)">
                        <path
                            clipRule="evenodd"
                            d="M10 4.96663L15.8643 15.3954H4.13572L10 4.96663ZM10.6973 3.0079C10.3914 2.46416 9.60858 2.46416 9.30274 3.0079L2.1039 15.8064C1.80394 16.3396 2.18931 16.9985 2.80116 16.9985H17.1988C17.8107 16.9985 18.1961 16.3396 17.8961 15.8063L10.6973 3.0079ZM10.7796 13.7697C10.7796 13.3394 10.4308 12.9906 10.0004 12.9906C9.5701 12.9906 9.22125 13.3394 9.22125 13.7697V13.8146C9.22125 14.2449 9.5701 14.5937 10.0004 14.5937C10.4308 14.5937 10.7796 14.2449 10.7796 13.8146V13.7697ZM10.0004 8.18128C10.4307 8.18128 10.7796 8.53013 10.7796 8.96046V11.4101C10.7796 11.8404 10.4307 12.1892 10.0004 12.1892C9.57008 12.1892 9.22123 11.8404 9.22123 11.4101V8.96046C9.22123 8.53013 9.57008 8.18128 10.0004 8.18128Z"
                            fill={color || "currentColor"}
                            fillRule="evenodd"
                        />
                    </g>
                </svg>
            );
        case "purge-cache":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 24 24"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M21.2 12C21.2 12.4418 21.5582 12.8 22 12.8C22.4418 12.8 22.8 12.4418 22.8 12H21.2ZM19.6217 5.52623L20.2314 5.00833L20.2314 5.00833L19.6217 5.52623ZM6.84473 3.43128L6.43231 2.74579L6.43231 2.74579L6.84473 3.43128ZM2.5236 8.80659L1.76549 8.55112L1.76549 8.55112L2.5236 8.80659ZM14.3209 22.5477C14.7524 22.4527 15.0252 22.0259 14.9303 21.5944C14.8353 21.1629 14.4086 20.8901 13.9771 20.985L14.3209 22.5477ZM10.0571 18C10.0571 18.4418 10.4153 18.8 10.8571 18.8C11.299 18.8 11.6571 18.4418 11.6571 18H10.0571ZM11.6571 16.794C11.6571 16.3521 11.299 15.994 10.8571 15.994C10.4153 15.994 10.0571 16.3521 10.0571 16.794H11.6571ZM12.3429 18C12.3429 18.4418 12.701 18.8 13.1429 18.8C13.5847 18.8 13.9429 18.4418 13.9429 18H12.3429ZM13.9429 15.5879C13.9429 15.1461 13.5847 14.7879 13.1429 14.7879C12.701 14.7879 12.3429 15.1461 12.3429 15.5879H13.9429ZM8 10.7638H7.2H8ZM22.8 12C22.8 9.43859 21.8896 6.96056 20.2314 5.00833L19.012 6.04414C20.4245 7.70714 21.2 9.81806 21.2 12H22.8ZM20.2314 5.00833C18.5732 3.0561 16.2751 1.75678 13.7475 1.34233L13.4886 2.92125C15.6418 3.27429 17.5994 4.38113 19.012 6.04414L20.2314 5.00833ZM13.7475 1.34233C11.2198 0.927889 8.62712 1.42531 6.43231 2.74579L7.25715 4.11678C9.12681 2.99193 11.3354 2.5682 13.4886 2.92125L13.7475 1.34233ZM6.43231 2.74579C4.2375 4.06626 2.58346 6.12382 1.76549 8.55112L3.28172 9.06207C3.9785 6.99437 5.3875 5.24163 7.25715 4.11678L6.43231 2.74579ZM1.76549 8.55112C0.947526 10.9784 1.01889 13.6174 1.96684 15.997L3.45324 15.4048C2.64572 13.3778 2.58493 11.1298 3.28172 9.06207L1.76549 8.55112ZM1.96684 15.997C2.91479 18.3765 4.67762 20.3417 6.94059 21.5416L7.69013 20.128C5.76242 19.1059 4.26075 17.4318 3.45324 15.4048L1.96684 15.997ZM6.94059 21.5416C9.20355 22.7415 11.8193 23.0981 14.3209 22.5477L13.9771 20.985C11.8461 21.4539 9.61784 21.1502 7.69013 20.128L6.94059 21.5416ZM11.6571 18V16.794H10.0571V18H11.6571ZM13.9429 18V15.5879H12.3429V18H13.9429ZM14.8571 18.8C15.2352 18.8 15.5884 18.6411 15.8419 18.3737L14.6805 17.2731C14.7197 17.2318 14.7822 17.2 14.8571 17.2V18.8ZM15.8419 18.3737C16.094 18.1076 16.2286 17.7556 16.2286 17.397H14.6286C14.6286 17.3582 14.6428 17.3129 14.6805 17.2731L15.8419 18.3737ZM16.2286 17.397V11.9698H14.6286V17.397H16.2286ZM15.4286 11.1698H8.57143V12.7698H15.4286V11.1698ZM7.77143 11.9698V17.397H9.37143V11.9698H7.77143ZM7.77143 17.397C7.77143 17.7556 7.90603 18.1076 8.15811 18.3737L9.31949 17.2731C9.35724 17.3129 9.37143 17.3582 9.37143 17.397H7.77143ZM8.15811 18.3737C8.41157 18.6411 8.76482 18.8 9.14286 18.8V17.2C9.21779 17.2 9.28035 17.2318 9.31949 17.2731L8.15811 18.3737ZM9.14286 18.8H14.8571V17.2H9.14286V18.8ZM8.57143 11.1698C8.64636 11.1698 8.70892 11.2017 8.74806 11.243L7.58668 12.3435C7.84014 12.611 8.19339 12.7698 8.57143 12.7698V11.1698ZM8.74806 11.243C8.78581 11.2828 8.8 11.3281 8.8 11.3668H7.2C7.2 11.7255 7.3346 12.0775 7.58668 12.3435L8.74806 11.243ZM8.8 11.3668V10.7638H7.2V11.3668H8.8ZM8.8 10.7638C8.8 10.6427 8.84601 10.5345 8.91542 10.4613L7.75405 9.36075C7.3948 9.73985 7.2 10.2453 7.2 10.7638L8.8 10.7638ZM8.91542 10.4613C8.98345 10.3895 9.06624 10.3578 9.14286 10.3578V8.75779C8.61327 8.75779 8.11467 8.98019 7.75405 9.36075L8.91542 10.4613ZM9.14286 10.3578H10.2857V8.75779H9.14286V10.3578ZM10.2857 10.3578C10.6638 10.3578 11.017 10.1989 11.2705 9.93144L10.1091 8.8309C10.1482 8.7896 10.2108 8.75779 10.2857 8.75779V10.3578ZM11.2705 9.93144C11.5225 9.66543 11.6571 9.3134 11.6571 8.95477H10.0571C10.0571 8.916 10.0713 8.87074 10.1091 8.8309L11.2705 9.93144ZM11.6571 8.95477V7.20603H10.0571V8.95477H11.6571ZM11.6571 7.20603C11.6571 7.08487 11.7032 6.97676 11.7726 6.90351L10.6112 5.80297C10.2519 6.18206 10.0571 6.68747 10.0571 7.20603H11.6571ZM11.7726 6.90351C11.8406 6.83172 11.9234 6.8 12 6.8V5.2C11.4704 5.2 10.9718 5.42241 10.6112 5.80297L11.7726 6.90351ZM12 6.8C12.0766 6.8 12.1594 6.83172 12.2274 6.90351L13.3888 5.80297C13.0282 5.42241 12.5296 5.2 12 5.2V6.8ZM12.2274 6.90351C12.2968 6.97676 12.3429 7.08487 12.3429 7.20603H13.9429C13.9429 6.68747 13.7481 6.18206 13.3888 5.80297L12.2274 6.90351ZM12.3429 7.20603V8.95477H13.9429V7.20603H12.3429ZM12.3429 8.95477C12.3429 9.3134 12.4775 9.66543 12.7295 9.93144L13.8909 8.8309C13.9287 8.87074 13.9429 8.916 13.9429 8.95477H12.3429ZM12.7295 9.93144C12.983 10.1989 13.3362 10.3578 13.7143 10.3578V8.75779C13.7892 8.75779 13.8518 8.7896 13.8909 8.8309L12.7295 9.93144ZM13.7143 10.3578H14.8571V8.75779H13.7143V10.3578ZM14.8571 10.3578C14.9338 10.3578 15.0165 10.3895 15.0846 10.4613L16.246 9.36075C15.8853 8.9802 15.3867 8.75779 14.8571 8.75779V10.3578ZM15.0846 10.4613C15.154 10.5345 15.2 10.6427 15.2 10.7638H16.8C16.8 10.2453 16.6052 9.73985 16.246 9.36075L15.0846 10.4613ZM15.2 10.7638V11.3668H16.8V10.7638H15.2ZM15.2 11.3668C15.2 11.3281 15.2142 11.2828 15.2519 11.243L16.4133 12.3435C16.6654 12.0775 16.8 11.7255 16.8 11.3668H15.2ZM15.2519 11.243C15.2911 11.2017 15.3536 11.1698 15.4286 11.1698V12.7698C15.8066 12.7698 16.1599 12.611 16.4133 12.3435L15.2519 11.243Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case "save":
            return (
                <svg
                    fill="none"
                    height="20"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15 19V12C15 11.7348 14.8946 11.4804 14.7071 11.2929C14.5196 11.1054 14.2652 11 14 11H6C5.73478 11 5.48043 11.1054 5.29289 11.2929C5.10536 11.4804 5 11.7348 5 12V19M5 1V5C5 5.26522 5.10536 5.51957 5.29289 5.70711C5.48043 5.89464 5.73478 6 6 6H13M13.2 1C13.7275 1.00751 14.2307 1.22317 14.6 1.6L18.4 5.4C18.7768 5.76926 18.9925 6.27246 19 6.8V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H13.2Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );
        case "drag":
            return (
                <svg
                    fill="none"
                    height="16"
                    viewBox="0 0 16 16"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        cx="5"
                        cy="4"
                        fill={color || "currentColor"}
                        r="1.25"
                    />
                    <circle
                        cx="11"
                        cy="4"
                        fill={color || "currentColor"}
                        r="1.25"
                    />
                    <circle
                        cx="5"
                        cy="8"
                        fill={color || "currentColor"}
                        r="1.25"
                    />
                    <circle
                        cx="11"
                        cy="8"
                        fill={color || "currentColor"}
                        r="1.25"
                    />
                    <circle
                        cx="5"
                        cy="12"
                        fill={color || "currentColor"}
                        r="1.25"
                    />
                    <circle
                        cx="11"
                        cy="12"
                        fill={color || "currentColor"}
                        r="1.25"
                    />
                </svg>
            );
        case "cancel":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6 6L18 18"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M18 6L6 18"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeWidth="1.6"
                    />
                </svg>
            );
        case "store-ecomm":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3 6.75L7.1895 2.5605C7.36625 2.38269 7.57645 2.24162 7.80798 2.14542C8.03951 2.04923 8.28778 1.9998 8.5385 2H16.4615C16.7122 1.9998 16.9605 2.04923 17.192 2.14542C17.4235 2.24162 17.6337 2.38269 17.8105 2.5605L22 6.75M3 6.75H22M3 6.75V9.6C3 10.1039 3.20018 10.5872 3.5565 10.9435C3.91282 11.2998 4.39609 11.5 4.9 11.5M22 6.75V9.6C22 10.1039 21.7998 10.5872 21.4435 10.9435C21.0872 11.2998 20.6039 11.5 20.1 11.5M4.9 11.5V19.1C4.9 19.6039 5.10018 20.0872 5.4565 20.4435C5.81282 20.7998 6.29609 21 6.8 21H18.2C18.7039 21 19.1872 20.7998 19.5435 20.4435C19.8998 20.0872 20.1 19.6039 20.1 19.1V11.5M4.9 11.5C5.45505 11.4695 5.98516 11.2594 6.4105 10.9015C6.52385 10.8196 6.66015 10.7755 6.8 10.7755C6.93985 10.7755 7.07615 10.8196 7.1895 10.9015C7.61484 11.2594 8.14495 11.4695 8.7 11.5C9.25505 11.4695 9.78516 11.2594 10.2105 10.9015C10.3239 10.8196 10.4601 10.7755 10.6 10.7755C10.7399 10.7755 10.8761 10.8196 10.9895 10.9015C11.4148 11.2594 11.9449 11.4695 12.5 11.5C13.0551 11.4695 13.5852 11.2594 14.0105 10.9015C14.1239 10.8196 14.2601 10.7755 14.4 10.7755C14.5399 10.7755 14.6761 10.8196 14.7895 10.9015C15.2148 11.2594 15.7449 11.4695 16.3 11.5C16.8551 11.4695 17.3852 11.2594 17.8105 10.9015C17.9239 10.8196 18.0601 10.7755 18.2 10.7755C18.3399 10.7755 18.4761 10.8196 18.5895 10.9015C19.0148 11.2594 19.5449 11.4695 20.1 11.5M15.35 21V17.2C15.35 16.6961 15.1498 16.2128 14.7935 15.8565C14.4372 15.5002 13.9539 15.3 13.45 15.3H11.55C11.0461 15.3 10.5628 15.5002 10.2065 15.8565C9.85018 16.2128 9.65 16.6961 9.65 17.2V21"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );
        case "document":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7 13.0001H13M7 9.0001H9M7 17.0001H13M16 21.0001H18.5M17 21.0001H7.8C6.11984 21.0001 5.27976 21.0001 4.63803 20.6731C4.07354 20.3855 3.6146 19.9266 3.32698 19.3621C3 18.7203 3 17.8803 3 16.2001V5.75719C3 4.8518 3 4.3991 3.1902 4.13658C3.35611 3.90758 3.61123 3.75953 3.89237 3.72909C4.21467 3.6942 4.60772 3.9188 5.39382 4.368L5.70618 4.54649C5.99552 4.71183 6.14019 4.7945 6.29383 4.82687C6.42978 4.85551 6.57022 4.85551 6.70617 4.82687C6.85981 4.7945 7.00448 4.71183 7.29382 4.54649L9.20618 3.45372C9.49552 3.28838 9.64019 3.20571 9.79383 3.17334C9.92978 3.14469 10.0702 3.14469 10.2062 3.17334C10.3598 3.20571 10.5045 3.28838 10.7938 3.45372L12.7062 4.54649C12.9955 4.71183 13.1402 4.7945 13.2938 4.82687C13.4298 4.85551 13.5702 4.85551 13.7062 4.82687C13.8598 4.7945 14.0045 4.71183 14.2938 4.54649L14.6062 4.368C15.3923 3.9188 15.7853 3.6942 16.1076 3.72909C16.3888 3.75953 16.6439 3.90758 16.8098 4.13658C17 4.3991 17 4.8518 17 5.75719V14.0001M17 13.0001H21V19.0001C21 20.1047 20.1046 21.0001 19 21.0001C17.8954 21.0001 17 20.1047 17 19.0001V13.0001Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );

        case "print":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V11C2 10.4696 2.21071 9.96086 2.58579 9.58579C2.96086 9.21071 3.46957 9 4 9H20C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V16C22 16.5304 21.7893 17.0391 21.4142 17.4142C21.0391 17.7893 20.5304 18 20 18H18M6 9V3C6 2.73478 6.10536 2.48043 6.29289 2.29289C6.48043 2.10536 6.73478 2 7 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V9M7 14H17C17.5523 14 18 14.4477 18 15V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V15C6 14.4477 6.44772 14 7 14Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );

        case "receipt":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14 8H8M16 12H8M13 16H8M4 2V22L6 21L8 22L10 21L12 22L14 21L16 22L18 21L20 22V2L18 3L16 2L14 3L12 2L10 3L8 2L6 3L4 2Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );

        case "chevron-down":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6 9L12 15L18 9"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                    />
                </svg>
            );

        case "tune":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4 7h9M19 7h1M4 17h1M11 17h9M15 4v6M8 14v6"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );

        case "download":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 4v10m0 0 4-4m-4 4-4-4M5 17h14"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );

        case "columns":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4 6h16v12H4zM10 6v12m4-12v12"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );

        case "calendar":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8 7V5m8 2V5M5 9h14M7 5h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                    />
                </svg>
            );

        case "clock":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 7v5l3 2m6-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                    />
                </svg>
            );

        case "check":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.5 12.5 10.2 16 17.5 8.8"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.4"
                    />
                </svg>
            );

        case "external-link":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M20 4L12 12M20 4V8.5M20 4H15.5M19 12.5V16.8C19 17.9201 19 18.4802 18.782 18.908C18.5903 19.2843 18.2843 19.5903 17.908 19.782C17.4802 20 16.9201 20 15.8 20H7.2C6.0799 20 5.51984 20 5.09202 19.782C4.71569 19.5903 4.40973 19.2843 4.21799 18.908C4 18.4802 4 17.9201 4 16.8V8.2C4 7.0799 4 6.51984 4.21799 6.09202C4.40973 5.71569 4.71569 5.40973 5.09202 5.21799C5.51984 5 6.07989 5 7.2 5H11.5"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );
        case "show":
            return (
                <svg
                    fill="none"
                    height="13"
                    viewBox="0 0 20 13"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M18.6426 5.61955C18.8727 5.87446 19 6.20564 19 6.54901C19 6.89239 18.8727 7.22357 18.6426 7.47847C17.186 9.04607 13.8704 12.098 10 12.098C6.12956 12.098 2.81403 9.04607 1.35741 7.47847C1.12735 7.22357 1 6.89239 1 6.54901C1 6.20564 1.12735 5.87446 1.35741 5.61955C2.81403 4.05196 6.12956 1 10 1C13.8704 1 17.186 4.05196 18.6426 5.61955Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                    <path
                        d="M10.0001 9.32343C11.5324 9.32343 12.7746 8.08124 12.7746 6.54892C12.7746 5.0166 11.5324 3.77441 10.0001 3.77441C8.46778 3.77441 7.22559 5.0166 7.22559 6.54892C7.22559 8.08124 8.46778 9.32343 10.0001 9.32343Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.6"
                    />
                </svg>
            );
        case "accept-rounder":
            return (
                <svg
                    className="lucide lucide-circle-check-big fill-treez-green text-currentColor mr-1"
                    data-component-content="%7B%7D"
                    data-component-file="GuideCard.tsx"
                    data-component-line="150"
                    data-component-name="CheckCircle"
                    data-component-path="src/components/GuideCard.tsx"
                    data-lov-id="src/components/GuideCard.tsx:150:10"
                    data-lov-name="CheckCircle"
                    fill="none"
                    height="16"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                    <path d="m9 11 3 3L22 4"></path>
                </svg>
            );

        case "play-control":
            return (
                <svg
                    className="lucide lucide-play"
                    data-component-content="%7B%7D"
                    data-component-file="GuideCard.tsx"
                    data-component-line="176"
                    data-component-name="Play"
                    data-component-path="src/components/GuideCard.tsx"
                    data-lov-id="src/components/GuideCard.tsx:176:16"
                    data-lov-name="Play"
                    fill="none"
                    height="16"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <polygon points="6 3 20 12 6 21 6 3"></polygon>
                </svg>
            );

        case "guide":
            return (
                <svg
                    className="lucide lucide-book-open"
                    data-component-content="%7B%7D"
                    data-component-file="TreezSidebar.tsx"
                    data-component-line="39"
                    data-component-name="BookOpen"
                    data-component-path="src/components/TreezSidebar.tsx"
                    data-lov-id="src/components/TreezSidebar.tsx:39:16"
                    data-lov-name="BookOpen"
                    fill="none"
                    height="20"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M12 7v14"></path>
                    <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
                </svg>
            );
        case "home":
            return (
                <svg
                    fill="none"
                    height="20"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.6"
                    viewBox="0 0 20 20"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M3 9.5L10 3L17 9.5"></path>

                    <path d="M4 9.5v9h12v-9"></path>

                    <rect height="6" width="4" x="8" y="12.5"></rect>
                </svg>
            );
        case "news-release":
            return (
                <svg
                    height="18px"
                    version="1.1"
                    viewBox="0 0 24 24"
                    width="18px"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <defs>
                        <path
                            d="M5.76090896,5.25 C5.43749824,4.74484974 5.25,4.14432115 5.25,3.5 C5.25,1.70507456 6.70507456,0.25 8.5,0.25 C9.505219,0.25 10.4038479,0.706366544 11,1.42321299 C11.5961521,0.706366544 12.494781,0.25 13.5,0.25 C15.2949254,0.25 16.75,1.70507456 16.75,3.5 C16.75,4.14432115 16.5625018,4.74484974 16.239091,5.25 L21,5.25 C21.4142136,5.25 21.75,5.58578644 21.75,6 L21.75,11 C21.75,11.4142136 21.4142136,11.75 21,11.75 L19.75,11.75 L19.75,21 C19.75,21.4142136 19.4142136,21.75 19,21.75 L3,21.75 C2.58578644,21.75 2.25,21.4142136 2.25,21 L2.25,11.75 L1,11.75 C0.585786438,11.75 0.25,11.4142136 0.25,11 L0.25,6 C0.25,5.58578644 0.585786438,5.25 1,5.25 L5.76090896,5.25 Z M8.75,6.75 L8.75,20.25 L13.25,20.25 L13.25,6.75 L11.75,6.75 L8.75,6.75 Z M7.25,20.25 L7.25,11.75 L3.75,11.75 L3.75,20.25 L7.25,20.25 Z M14.75,20.25 L18.25,20.25 L18.25,11.75 L14.75,11.75 L14.75,20.25 Z M7.25,6.75 L1.75,6.75 L1.75,10.25 L7.25,10.25 L7.25,6.75 Z M14.75,6.75 L14.75,10.25 L20.25,10.25 L20.25,6.75 L14.75,6.75 Z M10.25,5.25 L10.25,3.5 C10.25,2.53350169 9.46649831,1.75 8.5,1.75 C7.53350169,1.75 6.75,2.53350169 6.75,3.5 C6.75,4.46649831 7.53350169,5.25 8.5,5.25 L10.25,5.25 Z M11.75,5.25 L13.5,5.25 C14.4664983,5.25 15.25,4.46649831 15.25,3.5 C15.25,2.53350169 14.4664983,1.75 13.5,1.75 C12.5335017,1.75 11.75,2.53350169 11.75,3.5 L11.75,5.25 Z"
                            id="path-1"
                        ></path>
                    </defs>
                    <g
                        fill="none"
                        fillRule="evenodd"
                        id="Icon/SideNav/Whats-New"
                        stroke="none"
                        strokeWidth="1"
                    >
                        <g
                            id="Fill/Dark-Grey"
                            transform="translate(1.000000, 1.000000)"
                        >
                            <mask fill="white" id="mask-2">
                                <use xlinkHref="#path-1"></use>
                            </mask>
                            <use
                                fill="currentColor"
                                fillRule="nonzero"
                                id="Mask"
                                xlinkHref="#path-1"
                            ></use>
                            <g
                                fill="currentColor"
                                id="Color/Medium-Grey"
                                mask="url(#mask-2)"
                            >
                                <g
                                    id="Rectangle"
                                    transform="translate(-1.000000, -1.000000)"
                                >
                                    <rect
                                        height="24"
                                        width="24"
                                        x="0"
                                        y="0"
                                    ></rect>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            );

        case "account":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5.85 17.1C6.7 16.45 7.65 15.9373 8.7 15.562C9.75 15.1873 10.85 15 12 15C13.15 15 14.25 15.1873 15.3 15.562C16.35 15.9373 17.3 16.45 18.15 17.1C18.7333 16.4167 19.1877 15.6417 19.513 14.775C19.8377 13.9083 20 12.9833 20 12C20 9.78333 19.221 7.89567 17.663 6.337C16.1043 4.779 14.2167 4 12 4C9.78333 4 7.896 4.779 6.338 6.337C4.77933 7.89567 4 9.78333 4 12C4 12.9833 4.16267 13.9083 4.488 14.775C4.81267 15.6417 5.26667 16.4167 5.85 17.1ZM12 13C11.0167 13 10.1873 12.6627 9.512 11.988C8.83733 11.3127 8.5 10.4833 8.5 9.5C8.5 8.51667 8.83733 7.68733 9.512 7.012C10.1873 6.33733 11.0167 6 12 6C12.9833 6 13.8127 6.33733 14.488 7.012C15.1627 7.68733 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1627 11.3127 14.488 11.988C13.8127 12.6627 12.9833 13 12 13ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22ZM12 20C12.8833 20 13.7167 19.871 14.5 19.613C15.2833 19.3543 16 18.9833 16.65 18.5C16 18.0167 15.2833 17.6457 14.5 17.387C13.7167 17.129 12.8833 17 12 17C11.1167 17 10.2833 17.129 9.5 17.387C8.71667 17.6457 8 18.0167 7.35 18.5C8 18.9833 8.71667 19.3543 9.5 19.613C10.2833 19.871 11.1167 20 12 20ZM12 11C12.4333 11 12.7917 10.8583 13.075 10.575C13.3583 10.2917 13.5 9.93333 13.5 9.5C13.5 9.06667 13.3583 8.70833 13.075 8.425C12.7917 8.14167 12.4333 8 12 8C11.5667 8 11.2083 8.14167 10.925 8.425C10.6417 8.70833 10.5 9.06667 10.5 9.5C10.5 9.93333 10.6417 10.2917 10.925 10.575C11.2083 10.8583 11.5667 11 12 11Z"
                        fill={color || "currentColor"}
                    />
                </svg>
            );
        case "accounts":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2 21C2.00012 19.741 2.29739 18.4997 2.86766 17.3772C3.43792 16.2548 4.26506 15.2827 5.28182 14.5402C6.29858 13.7976 7.47624 13.3056 8.71904 13.104C9.96183 12.9024 11.2347 12.9969 12.434 13.38M19.5001 14.3L19.1001 15.2M16.9 20.8L16.5 21.7001M21.7001 19.5001L20.8 19.1001M15.2 16.9L14.3 16.5M21.7001 16.5L20.8 16.9M15.2 19.1001L14.3 19.5001M19.5001 21.7001L19.1001 20.8M16.9 15.2L16.5 14.3M15 8C15 10.7614 12.7614 13 10 13C7.23858 13 5 10.7614 5 8C5 5.23858 7.23858 3 10 3C12.7614 3 15 5.23858 15 8ZM21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C19.6569 15 21 16.3431 21 18Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );
        case "apps":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_40000012_87124)">
                        <path
                            d="M19.439 7.85005C19.39 8.17205 19.4981 8.49805 19.7281 8.72805L21.296 10.296C21.766 10.766 22.0021 11.383 22.0021 12C22.0021 12.617 21.767 13.233 21.296 13.704L19.685 15.315C19.5768 15.4232 19.4447 15.5045 19.2993 15.5524C19.154 15.6004 18.9994 15.6136 18.848 15.591C18.378 15.521 18.046 15.111 17.88 14.666C17.7344 14.2728 17.4922 13.9226 17.1758 13.6474C16.8593 13.3723 16.4788 13.1811 16.0692 13.0915C15.6595 13.0019 15.2339 13.0168 14.8315 13.1347C14.4291 13.2526 14.0628 13.4698 13.7663 13.7663C13.4698 14.0628 13.2526 14.4291 13.1347 14.8315C13.0168 15.2339 13.0019 15.6595 13.0915 16.0692C13.1811 16.4788 13.3723 16.8593 13.6474 17.1758C13.9226 17.4922 14.2728 17.7344 14.666 17.88C15.112 18.046 15.521 18.377 15.591 18.848C15.6137 18.9994 15.6005 19.154 15.5526 19.2994C15.5046 19.4447 15.4233 19.5768 15.315 19.685L13.705 21.295C13.4814 21.5194 13.2157 21.6974 12.9231 21.8187C12.6305 21.94 12.3168 22.0023 12 22.0021C11.6835 22.0025 11.37 21.9403 11.0776 21.8191C10.7852 21.698 10.5195 21.5202 10.296 21.296L8.72805 19.7281C8.61472 19.6145 8.47634 19.5291 8.32403 19.4788C8.17172 19.4284 8.00972 19.4145 7.85105 19.438C7.35805 19.512 7.01105 19.942 6.83105 20.406C6.68017 20.7933 6.43513 21.1368 6.11809 21.4056C5.80105 21.6743 5.42202 21.8598 5.01528 21.9452C4.60853 22.0306 4.18692 22.0132 3.78857 21.8947C3.39022 21.7761 3.02771 21.5602 2.73383 21.2663C2.43995 20.9724 2.22397 20.6099 2.10543 20.2115C1.98689 19.8132 1.96954 19.3916 2.05494 18.9848C2.14033 18.5781 2.32579 18.199 2.59452 17.882C2.86325 17.565 3.20679 17.3199 3.59405 17.169C4.05805 16.989 4.48805 16.642 4.56105 16.149C4.58476 15.9905 4.57097 15.8285 4.52079 15.6762C4.4706 15.5239 4.38541 15.3855 4.27205 15.272L2.70405 13.704C2.4799 13.4805 2.30213 13.2149 2.18097 12.9225C2.05981 12.6301 1.99765 12.3166 1.99805 12C1.99805 11.383 2.23405 10.766 2.70405 10.296L4.23005 8.77005C4.47005 8.53005 4.81105 8.41705 5.14705 8.46705C5.66205 8.54405 6.02405 8.99505 6.22005 9.47705C6.37575 9.8588 6.62344 10.1961 6.94106 10.459C7.25869 10.7218 7.63639 10.902 8.04052 10.9835C8.44466 11.0651 8.86269 11.0454 9.25737 10.9263C9.65206 10.8071 10.0112 10.5922 10.3027 10.3007C10.5942 10.0092 10.8091 9.65006 10.9283 9.25537C11.0474 8.86069 11.0671 8.44266 10.9855 8.03852C10.904 7.63439 10.7238 7.25669 10.461 6.93906C10.1981 6.62144 9.8608 6.37375 9.47905 6.21805C8.99705 6.02205 8.54605 5.66005 8.46905 5.14505C8.41905 4.80905 8.53105 4.46905 8.77205 4.22805L10.297 2.70305C10.5205 2.4792 10.786 2.30168 11.0782 2.1807C11.3705 2.05972 11.6837 1.99765 12 1.99805C12.617 1.99805 13.234 2.23405 13.704 2.70405L15.272 4.27205C15.502 4.50205 15.828 4.61005 16.149 4.56205C16.642 4.48805 16.989 4.05805 17.169 3.59405C17.3199 3.20679 17.565 2.86325 17.882 2.59452C18.199 2.32579 18.5781 2.14033 18.9848 2.05494C19.3916 1.96954 19.8132 1.98689 20.2115 2.10543C20.6099 2.22397 20.9724 2.43995 21.2663 2.73383C21.5602 3.02771 21.7761 3.39022 21.8947 3.78857C22.0132 4.18692 22.0306 4.60853 21.9452 5.01528C21.8598 5.42202 21.6743 5.80105 21.4056 6.11809C21.1368 6.43513 20.7933 6.68017 20.406 6.83105C19.942 7.01105 19.512 7.35705 19.439 7.85005Z"
                            stroke={color || "currentColor"}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_40000012_87124">
                            <rect fill="white" height="24" width="24" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "apps-icon":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7.5 4.27002L16.5 9.42002M3.30005 7L12 12M12 12L20.7001 7M12 12L12 22M21 7.9999C20.9996 7.64918 20.9071 7.30471 20.7315 7.00106C20.556 6.69742 20.3037 6.44526 20 6.2699L13 2.2699C12.696 2.09437 12.3511 2.00195 12 2.00195C11.6489 2.00195 11.304 2.09437 11 2.2699L4 6.2699C3.69626 6.44526 3.44398 6.69742 3.26846 7.00106C3.09294 7.30471 3.00036 7.64918 3 7.9999V15.9999C3.00036 16.3506 3.09294 16.6951 3.26846 16.9987C3.44398 17.3024 3.69626 17.5545 4 17.7299L11 21.7299C11.304 21.9054 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9054 13 21.7299L20 17.7299C20.3037 17.5545 20.556 17.3024 20.7315 16.9987C20.9071 16.6951 20.9996 16.3506 21 15.9999V7.9999Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );
        case "sign-out":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15.325 16.275C15.1417 16.0583 15.05 15.8123 15.05 15.537C15.05 15.2623 15.1417 15.0333 15.325 14.85L17.175 13H10C9.71667 13 9.47933 12.904 9.288 12.712C9.096 12.5207 9 12.2833 9 12C9 11.7167 9.096 11.479 9.288 11.287C9.47933 11.0957 9.71667 11 10 11H17.175L15.325 9.15C15.125 8.95 15.025 8.71267 15.025 8.438C15.025 8.16267 15.125 7.925 15.325 7.725C15.5083 7.525 15.7377 7.425 16.013 7.425C16.2877 7.425 16.5167 7.51667 16.7 7.7L20.3 11.3C20.4 11.4 20.471 11.5083 20.513 11.625C20.5543 11.7417 20.575 11.8667 20.575 12C20.575 12.1333 20.5543 12.2583 20.513 12.375C20.471 12.4917 20.4 12.6 20.3 12.7L16.7 16.3C16.4833 16.5167 16.246 16.6123 15.988 16.587C15.7293 16.5623 15.5083 16.4583 15.325 16.275ZM5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V5C3 4.45 3.19567 3.979 3.587 3.587C3.979 3.19567 4.45 3 5 3H11C11.2833 3 11.521 3.09567 11.713 3.287C11.9043 3.479 12 3.71667 12 4C12 4.28333 11.9043 4.52067 11.713 4.712C11.521 4.904 11.2833 5 11 5H5V19H11C11.2833 19 11.521 19.096 11.713 19.288C11.9043 19.4793 12 19.7167 12 20C12 20.2833 11.9043 20.5207 11.713 20.712C11.521 20.904 11.2833 21 11 21H5Z"
                        fill={color || "currentColor"}
                    />
                </svg>
            );
        case "close":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M18 6L6 18M6 6L18 18"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );
        case "eye-off":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9.87988 9.87988C9.58514 10.1545 9.34873 10.4857 9.18476 10.8537C9.02079 11.2217 8.93262 11.619 8.92552 12.0218C8.91841 12.4246 8.99251 12.8247 9.14339 13.1983C9.29428 13.5718 9.51885 13.9112 9.80373 14.196C10.0886 14.4809 10.4279 14.7055 10.8015 14.8564C11.175 15.0073 11.5752 15.0814 11.978 15.0742C12.3808 15.0671 12.778 14.979 13.146 14.815C13.514 14.651 13.8452 14.4146 14.1199 14.1199M10.73 5.08C11.1513 5.02751 11.5754 5.00079 12 5C19 5 22 12 22 12C21.5529 12.9571 20.9922 13.8569 20.33 14.68M6.61 6.61011C4.62125 7.96473 3.02987 9.82537 2 12.0001C2 12.0001 5 19.0001 12 19.0001C13.9159 19.0052 15.7908 18.4452 17.39 17.3901M2 2L22 22"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );
        case "eye":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2 12C2 12 5 5 12 5C19 5 22 12 22 12C22 12 19 19 12 19C5 19 2 12 2 12Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                    <path
                        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );
        case "error-icon":
            return (
                <svg
                    fill="none"
                    height="25"
                    viewBox="0 0 24 25"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5C5.92487 1.5 1 6.42487 1 12.5C1 18.5751 5.92487 23.5 12 23.5Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                    <path
                        d="M12 13.7222L12 7.61106"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                    <path
                        d="M12.0001 16.1666C11.3251 16.1666 10.7779 16.7138 10.7779 17.3889C10.7779 18.0639 11.3251 18.6111 12.0001 18.6111C12.6751 18.6111 13.2224 18.0639 13.2224 17.3889C13.2224 16.7138 12.6751 16.1666 12.0001 16.1666Z"
                        fill="#DE2D2C"
                    />
                </svg>
            );
        case "info-icon":
            return (
                <svg
                    fill="none"
                    height="25"
                    viewBox="0 0 24 25"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5C5.92487 1.5 1 6.42487 1 12.5C1 18.5751 5.92487 23.5 12 23.5Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                    <path
                        d="M12 11.2778L12 17.3889"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                    <path
                        d="M11.9998 8.83336C12.6749 8.83336 13.2221 8.28615 13.2221 7.61114C13.2221 6.93612 12.6749 6.38892 11.9998 6.38892C11.3248 6.38892 10.7776 6.93612 10.7776 7.61114C10.7776 8.28615 11.3248 8.83336 11.9998 8.83336Z"
                        fill={color || "currentColor"}
                    />
                </svg>
            );
        case "success-icon":
            return (
                <svg
                    fill="none"
                    height="25"
                    viewBox="0 0 24 25"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5C5.92487 1.5 1 6.42487 1 12.5C1 18.5751 5.92487 23.5 12 23.5Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                    <path
                        d="M8.33337 13.9352L10.8389 16.027C10.9062 16.0848 10.985 16.1262 11.0696 16.1483C11.1542 16.1704 11.2424 16.1725 11.3278 16.1545C11.4141 16.1376 11.4959 16.1015 11.5676 16.0487C11.6393 15.9959 11.6992 15.9276 11.7434 15.8484L15.6667 8.83325"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );
        case "warning-icon":
            return (
                <svg
                    fill="none"
                    height="27"
                    viewBox="0 0 27 27"
                    width="27"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.5 10.125V14.625M13.5 19.125H13.5113M24.4463 20.25L15.4463 4.50001C15.25 4.15374 14.9654 3.86572 14.6216 3.66534C14.2777 3.46495 13.8868 3.35937 13.4888 3.35938C13.0908 3.35937 12.6999 3.46495 12.356 3.66534C12.0121 3.86572 11.7275 4.15374 11.5313 4.50001L2.53126 20.25C2.3329 20.5935 2.22889 20.9834 2.22977 21.3801C2.23065 21.7768 2.33639 22.1662 2.53626 22.5088C2.73614 22.8515 3.02305 23.1352 3.36792 23.3312C3.71279 23.5272 4.10335 23.6286 4.50001 23.625H22.5C22.8948 23.6246 23.2825 23.5203 23.6242 23.3227C23.9659 23.1251 24.2496 22.841 24.4468 22.499C24.644 22.157 24.7478 21.7692 24.7477 21.3744C24.7476 20.9797 24.6436 20.5919 24.4463 20.25Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );
        case "products":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <mask
                        height="24"
                        id="mask0_4312_60259"
                        maskUnits="userSpaceOnUse"
                        style={{ maskType: "alpha" }}
                        width="24"
                        x="0"
                        y="0"
                    >
                        <rect fill="#D9D9D9" height="24" width="24" />
                    </mask>
                    <g mask="url(#mask0_4312_60259)">
                        <path
                            d="M8.275 11C7.89167 11 7.6 10.8294 7.4 10.488C7.2 10.146 7.20833 9.80838 7.425 9.47505L11.15 3.40005C11.35 3.08338 11.6333 2.92505 12 2.92505C12.3667 2.92505 12.65 3.08338 12.85 3.40005L16.575 9.47505C16.7917 9.80838 16.8 10.146 16.6 10.488C16.4 10.8294 16.1083 11 15.725 11H8.275ZM17.5 22C16.25 22 15.1873 21.5627 14.312 20.688C13.4373 19.8127 13 18.75 13 17.5C13 16.25 13.4373 15.1874 14.312 14.312C15.1873 13.4374 16.25 13 17.5 13C18.75 13 19.8127 13.4374 20.688 14.312C21.5627 15.1874 22 16.25 22 17.5C22 18.75 21.5627 19.8127 20.688 20.688C19.8127 21.5627 18.75 22 17.5 22ZM4 21.5C3.71667 21.5 3.47933 21.404 3.288 21.212C3.096 21.0207 3 20.7834 3 20.5V14.5C3 14.2167 3.096 13.979 3.288 13.787C3.47933 13.5957 3.71667 13.5 4 13.5H10C10.2833 13.5 10.521 13.5957 10.713 13.787C10.9043 13.979 11 14.2167 11 14.5V20.5C11 20.7834 10.9043 21.0207 10.713 21.212C10.521 21.404 10.2833 21.5 10 21.5H4ZM17.5 20C18.2 20 18.7917 19.7584 19.275 19.275C19.7583 18.7917 20 18.2 20 17.5C20 16.8 19.7583 16.2084 19.275 15.725C18.7917 15.2417 18.2 15 17.5 15C16.8 15 16.2083 15.2417 15.725 15.725C15.2417 16.2084 15 16.8 15 17.5C15 18.2 15.2417 18.7917 15.725 19.275C16.2083 19.7584 16.8 20 17.5 20ZM5 19.5H9V15.5H5V19.5ZM10.05 9.00005H13.95L12 5.85005L10.05 9.00005Z"
                            fill="#1A1A1A"
                        />
                    </g>
                </svg>
            );
        case "groups":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <mask
                        height="24"
                        id="mask0_2299_50777"
                        maskUnits="userSpaceOnUse"
                        style={{ maskType: "alpha" }}
                        width="24"
                        x="0"
                        y="0"
                    >
                        <rect fill="#D9D9D9" height="24" width="24" />
                    </mask>
                    <g mask="url(#mask0_2299_50777)">
                        <path
                            d="M3 21C2.45 21 1.97933 20.8043 1.588 20.413C1.196 20.021 1 19.55 1 19V6H3V19H20V21H3ZM7 17C6.45 17 5.97933 16.8043 5.588 16.413C5.196 16.021 5 15.55 5 15V4C5 3.45 5.196 2.979 5.588 2.587C5.97933 2.19567 6.45 2 7 2H12L14 4H21C21.55 4 22.021 4.196 22.413 4.588C22.8043 4.97933 23 5.45 23 6V15C23 15.55 22.8043 16.021 22.413 16.413C22.021 16.8043 21.55 17 21 17H7ZM7 15H21V6H13.175L11.175 4H7V15Z"
                            fill="#1A1A1A"
                        />
                    </g>
                </svg>
            );
        case "discounts":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <mask
                        height="24"
                        id="mask0_4312_60258"
                        maskUnits="userSpaceOnUse"
                        style={{ maskType: "alpha" }}
                        width="24"
                        x="0"
                        y="0"
                    >
                        <rect fill="#D9D9D9" height="24" width="24" />
                    </mask>
                    <g mask="url(#mask0_4312_60258)">
                        <path
                            d="M14.25 21.4C13.8667 21.7833 13.3917 21.975 12.825 21.975C12.2583 21.975 11.7833 21.7833 11.4 21.4L2.6 12.6C2.41667 12.4167 2.271 12.2 2.163 11.95C2.05433 11.7 2 11.4333 2 11.15V4C2 3.45 2.196 2.979 2.588 2.587C2.97933 2.19567 3.45 2 4 2H11.15C11.4333 2 11.7 2.054 11.95 2.162C12.2 2.27067 12.4167 2.41667 12.6 2.6L21.4 11.425C21.7833 11.8083 21.975 12.279 21.975 12.837C21.975 13.3957 21.7833 13.8667 21.4 14.25L14.25 21.4ZM12.825 20L19.975 12.85L11.15 4H4V11.15L12.825 20ZM6.5 8C6.91667 8 7.27067 7.854 7.562 7.562C7.854 7.27067 8 6.91667 8 6.5C8 6.08333 7.854 5.72933 7.562 5.438C7.27067 5.146 6.91667 5 6.5 5C6.08333 5 5.72933 5.146 5.438 5.438C5.146 5.72933 5 6.08333 5 6.5C5 6.91667 5.146 7.27067 5.438 7.562C5.72933 7.854 6.08333 8 6.5 8Z"
                            fill="#1A1A1A"
                        />
                    </g>
                </svg>
            );
        case "generate-password":
            return (
                <svg
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14 7.00049L17 10.0005M9.4 10.6006L2 18.0006V21.0006C2 21.6006 2.4 22.0006 3 22.0006H7V19.0006H10V16.0006H12L13.4 14.6006M12.3999 2.70039C13.2999 1.80039 14.8999 1.80039 15.7999 2.70039L21.2999 8.20039C22.1999 9.10039 22.1999 10.7004 21.2999 11.6004L17.5999 15.3004C16.6999 16.2004 15.0999 16.2004 14.1999 15.3004L8.6999 9.80039C7.7999 8.90039 7.7999 7.30039 8.6999 6.40039L12.3999 2.70039Z"
                        stroke={color || "currentColor"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                    />
                </svg>
            );
        default:
            return null;
    }
};

export default Icon;
